import { getSessionToken } from "@descope/react-sdk";
import { useMemo } from "react";

function useAuthHeader(): Record<string, string> {
	const sessionToken = getSessionToken();
	return useMemo<Record<string, string>>(() => {
		if (sessionToken) {
			return { "Authorization": "Bearer " + sessionToken, "content-type": "application/json" };
		}
		return {} as Record<string, string>;
	}, [sessionToken]);
}

export default useAuthHeader;
